// extracted by mini-css-extract-plugin
export default {"Burger":"Burger_Burger__USPJj","Open":"Burger_Open__1t0-o"};